var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoogleWindmill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 257.537,
    x2: 386.67,
    y1: 384.5,
    y2: 384.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f90217"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 127.044,
    x2: 254.537,
    y1: 129.5,
    y2: 129.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28a265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28895e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 382.5,
    x2: 382.5,
    y1: 256.396,
    y2: 125.688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7faef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c8df1"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 329.265,
    x2: 271.277,
    y1: 232.235,
    y2: 174.247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c8df1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5721,
    stopColor: "#476fcb",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4256ac"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 127.5,
    x2: 127.5,
    y1: 385.39,
    y2: 257.676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2b631"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 383.982,
    x2: 383.982,
    y1: 183,
    y2: 127.918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c8df1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5631,
    stopColor: "#466cc8",
    stopOpacity: 0.563
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4256ac"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#108372",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006837"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 192.036,
    x2: 192.036,
    xlinkHref: "#lg1",
    y1: 76,
    y2: 6.971
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a126",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a126"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 127.5,
    x2: 127.5,
    xlinkHref: "#lg2",
    y1: 289,
    y2: 259.983
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 171.735,
    x2: 236.752,
    xlinkHref: "#lg2",
    y1: 272.765,
    y2: 337.783
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 318.555,
    x2: 318.555,
    y1: 328,
    y2: 244.946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f90217",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 275.515,
    x2: 331.188,
    y1: 335.515,
    y2: 279.843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f90217",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#ed0212",
    stopOpacity: 0.313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8796,
    stopColor: "#cd0003",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 220,
    x2: 256.222,
    xlinkHref: "#lg1",
    y1: 129.5,
    y2: 129.5
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(1 0 0 -1 0 512)",
    gradientUnits: "userSpaceOnUse",
    x1: 235.985,
    x2: 169.984,
    xlinkHref: "#lg1",
    y1: 176.985,
    y2: 242.986
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255 24.968c0-16.118 15.085-28.078 30.741-24.25 56.393 13.788 98.243 64.656 98.243 125.298 0 71.236-57.748 128.984-128.984 128.984z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 485.032c0 16.118-15.085 28.078-30.741 24.249-56.393-13.788-98.243-64.656-98.243-125.298 0-71.235 57.748-128.983 128.984-128.983z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.032 255c16.118 0 28.078 15.085 24.25 30.741-13.788 56.393-64.656 98.243-125.298 98.243-71.236 0-128.984-57.748-128.984-128.984z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 255c0 2.161.048 4.31.143 6.447 4.563 102.631 157.967 100.761 160.795-1.932.041-1.5.062-3.005.062-4.515z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.968 255c-16.118 0-28.078-15.085-24.25-30.741 13.788-56.393 64.656-98.243 125.298-98.243 71.236 0 128.984 57.748 128.984 128.984z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m272.26 319.492c22.302 38.552 63.983 64.492 111.724 64.492s89.418-25.94 111.72-64.492z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.071 412c10.594 47.832 47.741 85.681 95.188 97.282 15.656 3.828 30.741-8.132 30.741-24.25v-73.032z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.718 224.259c-3.828 15.656 8.132 30.741 24.25 30.741h230.032c0-23.494-6.285-45.52-17.26-64.492h-223.444c-6.027 10.418-10.644 21.753-13.578 33.751z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.062 250.485c-.041 1.5-.062 3.005-.062 4.515h161c0-2.161-.048-4.31-.143-6.447-4.563-102.631-157.967-100.761-160.795 1.932z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 148v107c63.74 0 116.675-46.238 127.11-107z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.515 94.062c-1.5-.041-3.005-.062-4.515-.062v161c2.161 0 4.31-.048 6.447-.143 102.631-4.563 100.761-157.967-1.932-160.795z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201 501.15c7.402 3.417 15.18 6.157 23.259 8.132 15.656 3.828 30.741-8.132 30.741-24.25v-230.032c-19.282 0-37.572 4.238-54 11.823z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.485 415.938c1.5.041 3.005.062 4.515.062v-161c-2.161 0-4.31.048-6.447.143-102.631 4.563-100.761 157.967 1.932 160.795z",
    fill: "url(#SVGID_13_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleWindmill);
export default __webpack_public_path__ + "static/media/icon-google-windmill.5536bdd1b4b2bb3cb2c7604a32981014.svg";
export { ForwardRef as ReactComponent };